import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";

const FAQComponent = () => {
  const faqData = [
    {
      category: "Datacom Shop Questions",
      questions: [
        {
          title: "What Payment Methods Does Datacom Offer?",
          content:
            "We offer a variety of payment methods, including Cash on Delivery, Credit/Debit Cards, and Online Bank Transfers.",
        },
        {
          title: "How will Datacom deliver my device?",
          content:
            "We partner with reliable courier services to ensure safe and timely delivery of your device to your doorstep.",
        },
        {
          title: "What products does Datacom offer?",
          content:
            "We offer a wide range of brand new mobile phones from various leading brands.",
        },
        {
          title: "What is Datacom?",
          content:
            "Datacom is your trusted online retailer for brand new mobile phones, providing cutting-edge technology and exceptional customer service.",
        },
        {
          title: "Does Datacom have a physical store?",
          content:
            "Currently, we operate exclusively online to provide you with the best prices and convenience.",
        },
        {
          title: "Can I return the device to Datacom?",
          content:
            "Yes, we have a return policy. Please refer to our Returns & Exchange page for details.",
        },
        {
          title: "How much does Datacom charge for delivery?",
          content: "We offer free express shipping across the country.",
        },
        {
          title: "Does Datacom sell brand new mobile phones?",
          content:
            "Yes, we specialize in selling 100% brand new and original mobile phones with official warranties.",
        },
        {
          title: "Does Datacom sell the latest mobile phones?",
          content:
            "Yes, we strive to offer the latest mobile phone models as soon as they are released.",
        },
      ],
    },
    {
      category: "Customer Support Questions",
      questions: [
        {
          title: "What is the response time at Datacom?",
          content:
            "We aim to respond to your inquiries as quickly as possible, typically within 24 hours.",
        },
        {
          title: "How to stay updated on Datacom's promotions and discounts?",
          content:
            "Subscribe to our newsletter and follow us on social media to stay informed about our latest deals.",
        },
        {
          title: "Does Datacom provide phones in every budget price range?",
          content:
            "Yes, we offer phones across various price ranges to cater to different budgets, from budget-friendly options to high-end models.",
        },
        {
          title: "How can I complain to Datacom?",
          content:
            "You can reach out to our customer support team through the Contact Us page or call us at our helpline.",
        },
        {
          title: "Can I sell my mobile phone on Datacom?",
          content:
            "Currently, we do not have a platform for individuals to sell their used or new mobile phones on Datacom.",
        },
        {
          title: "Why is Datacom the best place to buy mobile phones?",
          content:
            "We offer competitive prices, genuine products, fast shipping, and excellent customer service, all dedicated to providing you with the best mobile phone shopping experience.",
        },
        {
          title: "Can I trust Datacom with my mobile phone purchase?",
          content:
            "Yes, we are a reputable online retailer committed to providing our customers with a trustworthy and reliable shopping experience. All our phones come with official warranties.",
        },
        {
          title: "Does Datacom ship mobile phones overseas?",
          content: "Currently, we only ship within the country.",
        },
      ],
    },
  ];

  return (
    <Container>
      <Row>
        {/* Datacom Shop Questions */}
        <Col xs={12} md={6}>
          <div className="mb-4">
            <h2 className="mb-3">Datacom Shop Questions</h2>
            <Accordion defaultActiveKey="0">
              {faqData[0].questions.map((faq, idx) => (
                <Accordion.Item eventKey={idx.toString()} key={idx}>
                  <Accordion.Header>{faq.title}</Accordion.Header>
                  <Accordion.Body>{faq.content}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </Col>

        {/* Customer Support Questions */}
        <Col xs={12} md={6}>
          <div className="mb-4">
            <h2 className="mb-3">Customer Support Questions</h2>
            <Accordion defaultActiveKey="0">
              {faqData[1].questions.map((faq, idx) => (
                <Accordion.Item eventKey={idx.toString()} key={idx}>
                  <Accordion.Header>{faq.title}</Accordion.Header>
                  <Accordion.Body>{faq.content}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default FAQComponent;
